import {
  FETCH_RAW_STOCK_HISTORY_REQUEST,
  FETCH_RAW_STOCK_HISTORY_SUCCESS,
  FETCH_RAW_STOCK_HISTORY_FAILURE,
  FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_REQUEST,
  FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_SUCCESS,
  FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_FAILURE,
  FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_REQUEST,
  FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_SUCCESS,
  FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_FAILURE,
  FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_REQUEST,
  FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_SUCCESS,
  FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_FAILURE,
  CREATE_RAW_STOCK_HISTORY_REQUEST,
  CREATE_RAW_STOCK_HISTORY_SUCCESS,
  CREATE_RAW_STOCK_HISTORY_FAILURE,
  GET_RAW_STOCK_HISTORY_REPORT_REQUEST,
  GET_RAW_STOCK_HISTORY_REPORT_SUCCESS,
  GET_RAW_STOCK_HISTORY_REPORT_FAILURE
} from './rawStockHistoryActionTypes';

import {
  fetchRawStockHistory,
  fetchRawStockHistoryByStockCode,
  fetchRawStockHistoryByDateRange,
  fetchRawStockHistoryByCreatedBy,
  createRawStockHistory,
  getRawStockHistoryReport
} from '../../../api/rawStockHistory/rawStockHistoryApi';

// Fetch all raw stock history
export const fetchRawStockHistoryAction = () => async (dispatch) => {
  dispatch({ type: FETCH_RAW_STOCK_HISTORY_REQUEST });
  try {
    const response = await fetchRawStockHistory();
    dispatch({
      type: FETCH_RAW_STOCK_HISTORY_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_RAW_STOCK_HISTORY_FAILURE,
      payload: error.response?.data?.error || error.message
    });
  }
};

// Fetch raw stock history by stock code
export const fetchRawStockHistoryByStockCodeAction = (stockCode) => async (dispatch) => {
  dispatch({ type: FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_REQUEST });
  try {
    const response = await fetchRawStockHistoryByStockCode(stockCode);
    dispatch({
      type: FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_RAW_STOCK_HISTORY_BY_STOCK_CODE_FAILURE,
      payload: error.response?.data?.error || error.message
    });
  }
};

// Fetch raw stock history by date range
export const fetchRawStockHistoryByDateRangeAction = (dateFrom, dateTo) => async (dispatch) => {
  dispatch({ type: FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_REQUEST });
  try {
    const response = await fetchRawStockHistoryByDateRange(dateFrom, dateTo);
    dispatch({
      type: FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_RAW_STOCK_HISTORY_BY_DATE_RANGE_FAILURE,
      payload: error.response?.data?.error || error.message
    });
  }
};

// Fetch raw stock history by created by
export const fetchRawStockHistoryByCreatedByAction = (createdBy) => async (dispatch) => {
  dispatch({ type: FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_REQUEST });
  try {
    const response = await fetchRawStockHistoryByCreatedBy(createdBy);
    dispatch({
      type: FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: FETCH_RAW_STOCK_HISTORY_BY_CREATED_BY_FAILURE,
      payload: error.response?.data?.error || error.message
    });
  }
};

// Create raw stock history
export const createRawStockHistoryAction = (data) => async (dispatch) => {
  dispatch({ type: CREATE_RAW_STOCK_HISTORY_REQUEST });
  try {
    const response = await createRawStockHistory(data);
    dispatch({
      type: CREATE_RAW_STOCK_HISTORY_SUCCESS,
      payload: response.data
    });
    return response.data;
  } catch (error) {
    dispatch({
      type: CREATE_RAW_STOCK_HISTORY_FAILURE,
      payload: error.response?.data?.error || error.message
    });
    throw error;
  }
};

// Get raw stock history report
export const getRawStockHistoryReportAction = (filters) => async (dispatch) => {
  dispatch({ type: GET_RAW_STOCK_HISTORY_REPORT_REQUEST });
  try {
    const response = await getRawStockHistoryReport(filters);
    dispatch({
      type: GET_RAW_STOCK_HISTORY_REPORT_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    dispatch({
      type: GET_RAW_STOCK_HISTORY_REPORT_FAILURE,
      payload: error.response?.data?.error || error.message
    });
  }
}; 